import { render, staticRenderFns } from "./motherChildPieChart.vue?vue&type=template&id=edf9995c&scoped=true"
import script from "./motherChildPieChart.vue?vue&type=script&lang=js"
export * from "./motherChildPieChart.vue?vue&type=script&lang=js"
import style0 from "./motherChildPieChart.vue?vue&type=style&index=0&id=edf9995c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf9995c",
  null
  
)

export default component.exports